const MojeO2AppBannerMobileLink = 'https://moje.o2.cz/document-direct/?path=o2%2FMojeO2App-Mobile.jpg&site=o2';

export default MojeO2AppBannerMobileLink;
